import actionTypes from '../constants/action-types';

const changeColor = (paletteVariables) => ({
  type: actionTypes.CHANGE_COLOR,
  payload: {
    paletteVariables,
  },
});

export default changeColor;
